import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form as AForm } from 'antd';
import OnboardingBackground from '../../components/layouts/OnboardingBackground';
import { PageContent, PageContentWrapper } from '../../components/layouts/Wrapper.style';
import { SiteOnBoardCard, SiteOnBoardCardHeader, SiteOnBoardCardContent, SiteOnBoardCardHeaderProgress, } from './SiteOnboard.style';
import { Progress } from 'antd';
import Step1SiteDetails from './components/Step1SiteDetails';
import Step2SiteIcon from './components/Step2SiteIcon';
import Step3BusinessHours from './components/Step3BusinessHours';
import Step4SiteLocation from './components/Step4SiteLocation';
import { useSiteOnboard } from './hooks/useSiteOnboard';
const SiteOnBoard = () => {
    // ========== FORM REFS ==========
    const [locationHoursModal] = AForm.useForm();
    // ========== STATE & HANDLERS FROM HOOK ==========
    const { 
    // State
    validationError, imageCheck, imageUrl, imageBase64, currentStep, initialLocationHours, initialValuesStep1, optionsAddress, step1Loading, step2Loading, step3Loading, step4Loading, checkSiteResponse, 
    // Handlers
    handleFormSubmit, handleImageChange, handleImageUpload, handleFormSubmit3, handleAddressSelect, handleFourthStep, handleValuesChange, searchAddressDebounced, setCurrentStep, } = useSiteOnboard();
    // ==================== STEP CONFIGURATION ====================
    // Each step contains title, heading, and content (step component)
    const steps = [
        {
            title: 'Step 1',
            heading: 'Add some details about this site',
            content: (_jsx(Step1SiteDetails, { initialValues: initialValuesStep1, onSubmit: handleFormSubmit, loading: step1Loading })),
        },
        {
            title: 'Step 2',
            heading: 'Upload icon for your Site',
            content: (_jsx(Step2SiteIcon, { imageUrl: imageUrl, loading: step2Loading, onImageChange: handleImageChange, onContinue: handleImageUpload, onBack: () => setCurrentStep(currentStep - 1), imageCheck: imageCheck, imageBase64: imageBase64, existingImageUrl: checkSiteResponse?.imageUrl?.original })),
        },
        {
            title: 'Step 3',
            heading: 'Add your business hours',
            content: (_jsx(Step3BusinessHours, { initialLocationHours: initialLocationHours, onSubmit: handleFormSubmit3, onBack: () => setCurrentStep(currentStep - 1), loading: step3Loading, validationError: validationError, onValuesChange: handleValuesChange, locationHoursModal: locationHoursModal })),
        },
        {
            title: 'Step 4',
            heading: 'Add Site Location',
            content: (_jsx(Step4SiteLocation, { onBack: () => setCurrentStep(currentStep - 1), onContinue: handleFourthStep, loading: step4Loading, onAddressSelect: handleAddressSelect, optionsAddress: optionsAddress, onSearch: searchAddressDebounced })),
        },
    ];
    // ==================== PROGRESS CALCULATION ====================
    // Calculate progress percentage for the progress bar
    const progressPercentage = ((currentStep + 1) / steps?.length) * 100;
    return (_jsxs(_Fragment, { children: [_jsx(OnboardingBackground, {}), _jsx(PageContent, { center: true, children: _jsx(PageContentWrapper, { width: 780, children: _jsxs(SiteOnBoardCard, { children: [_jsx(SiteOnBoardCardHeader, { children: _jsx("h3", { children: steps[currentStep + 1]?.heading }) }), _jsxs(SiteOnBoardCardContent, { children: [_jsx(SiteOnBoardCardHeaderProgress, { children: _jsx(Progress, { percent: progressPercentage }) }), steps[currentStep + 1]?.content] })] }) }) })] }));
};
export default SiteOnBoard;
